import useLocalStorage from './useLocalStorage';
import useCurrentUser from './useCurrentUser';
import { useModal } from 'components/shared/hooks';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  defaultIgnorableLabel: {
    id: 'hooks.useIgnorableConfirmation.defaultIgnorableLabel',
    defaultMessage: "Don't show this message again",
    description: 'label text for a checkbox',
  },
});

const useIgnorableConfirmationModal = ({
  confirmationKey,
  confirmationAction,
  modalProps,
}) => {
  const intl = useIntl();
  const currentUser = useCurrentUser();
  const [isIgnored, setIgnored] = useLocalStorage(
    `confirmationIgnored:${confirmationKey}:${currentUser.node_id}`,
    false,
  );

  const { showModal, hideModal, Modal } = useModal();

  const doActionOrShowConfirmationModal = (params, overrideModalProps = {}) => {
    if (isIgnored) {
      confirmationAction(params);
    } else {
      showModal(Modal.CONFIRMATION, {
        ...modalProps,
        confirmAction: (_, isChecked) => {
          setIgnored(isChecked);
          confirmationAction(params);
          hideModal();
        },
        showCheckbox: true,
        checkboxText: intl.formatMessage(messages.defaultIgnorableLabel),
        ...overrideModalProps,
      });
    }
  };
  return { isIgnored, doActionOrShowConfirmationModal };
};

export default useIgnorableConfirmationModal;
